import React from "react";
import ReuseModal from "../../../../components/fragment/modal/ReuseModal";
import "../../../../styles/dashboard/third-party/ThirdPartyIndex.css";
import {
  RazorCopyText,
  RazorDateTime,
  RazorNumberFormat,
  RazorTextTrim,
  RazorToolTip,
  RazorGetValue,
} from "../../../../components/razor-reuse";
import { capitalizeFirstLetter } from "../../../../utils/Helper";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  payment_details?: any;
}

const ZojapayPaymentDetailsModal = ({
  onClose,
  visible,
  payment_details,
}: myComponentProps) => {
  const objListToView = [
    {
      key: "accountName",
      value: "",
      copy: true,
    },
    {
      key: "accountNumber",
      value: "",
      copy: true,
    },
    {
      key: "bankName",
      value: "",
      copy: true,
    },
  ];

  return (
    <>
      <ReuseModal
        title="Zojapay Account Details"
        visible={visible}
        onClose={onClose}
        hideBtn
      >
        <div
          // onClick={() => {
          //   console.log(blaze);
          // }}
          className="third-party-account-details-modal-wrap-index"
        >
          <div className="title-text-box">
            <p className="title">Fund Account</p>
            <p className="text">
              Make payment from your bank to the details below
            </p>
          </div>
          {/* wrapper start */}
          <div className="label-value-box-wrap">
            {RazorGetValue(objListToView, payment_details)?.map(
              (chi: any, idx) => {
                if (chi?.hide || !chi?.value) {
                  return <React.Fragment key={idx}></React.Fragment>;
                }
                return (
                  <div key={idx} className="label-value-box capitalize">
                    <p className="label">{chi?.key?.replaceAll("_", " ")}:</p>
                    <div
                      className={`value ${
                        String(chi?.value)?.length > 30 && !chi?.date
                          ? "tooltip-hover-wrap"
                          : ""
                      }`}
                      style={{ color: chi?.color ? chi?.color : "" }}
                    >
                      {chi?.date ? (
                        <RazorDateTime date={chi?.value} hideAgo />
                      ) : chi?.amount ? (
                        chi?.copy ? (
                          <RazorCopyText
                            textToCopy={RazorNumberFormat(chi?.value, {
                              symbol: chi?.symbol,
                              numberAbbreviate: String(chi?.value)?.length > 8,
                            })}
                            reference={RazorNumberFormat(chi?.value, {
                              symbol: chi?.symbol,
                              numberAbbreviate: String(chi?.value)?.length > 8,
                            })}
                            outerCopy
                          />
                        ) : (
                          RazorNumberFormat(chi?.value, {
                            symbol: chi?.symbol,
                            numberAbbreviate: String(chi?.value)?.length > 8,
                          })
                        )
                      ) : chi?.copy ? (
                        <RazorCopyText
                          textToCopy={chi?.value}
                          reference={RazorTextTrim(
                            capitalizeFirstLetter(chi?.value),
                            30,
                          )}
                          outerCopy
                        />
                      ) : (
                        RazorTextTrim(chi?.value, 30) || "---"
                      )}
                      <RazorToolTip
                        color="black-light"
                        text={chi?.value}
                        position={`top-center`}
                      />
                    </div>
                  </div>
                );
              },
            )}
          </div>
          <div
            className="-mt-[6px]"
            style={{ display: "flex", gap: 8, flexWrap: "wrap" }}
          >
            {payment_details?.payment_rails?.map((rail: string) => (
              <span
                key={rail}
                style={{
                  background: "rgba(99,102,241,0.18)",
                  border: "1px solid rgba(99,102,241,0.35)",
                  borderRadius: 20,
                  padding: "4px 10px",
                  fontSize: 10,
                  color: "#a5b4fc",
                  textTransform: "uppercase",
                  fontWeight: 600,
                }}
              >
                {rail?.replace("_", " ")}
              </span>
            ))}
          </div>
          {/* wrapper send */}
        </div>
      </ReuseModal>
    </>
  );
};

export default ZojapayPaymentDetailsModal;
